<template>
  <v-dialog v-model="dialog" scrollable persistent :width="esMovil ? '100%' : '600px'">
    <template v-slot:activator="{}">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click.stop="mostrarDialogo" icon v-on="on" v-bind="attrs">
            <v-icon color="primary">mdi-share-variant-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ $tc('compartir') }}</span>
      </v-tooltip>
    </template>
    <v-card class="primary--text">
      <v-card-title class="pt-2 pb-1 pl-2 pr-1 font-weight-bold title primary white--text">
        {{ titulo }}
        <v-spacer></v-spacer>
        <v-btn icon right @click="cerrar()" color="error">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-2">
        <v-row v-if="!loading">
          <v-col cols="8" align-self="center">
            <v-text-field type="text" v-model="url" readonly hide-details/>
          </v-col>
          <v-col cols="4" align-self="center">
            <v-btn color="primary" class="ma-auto" depressed @click="copiarEnlace">
              <v-icon class="mr-2">mdi-content-copy</v-icon>
              <span v-show="!esMovil">{{ $t('boton_copiar') }}</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="!loading" no-gutters>
          <v-col class="font-italic">
            {{ descripcion }}
          </v-col>
        </v-row>
        <v-row v-if="loading" class="pa-3">
          <v-col cols="8" align-self="center">
            <v-skeleton-loader type="text"/>
          </v-col>
          <v-col cols="4">
            <v-skeleton-loader height="36px" type="image"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="error" text @click="cerrar">
          {{ $t('cerrar') | capitalize }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {MOSTRAR_SNACKBAR} from "@/store/store-app";
import {RouteHelper} from "@/comunes/helpers/RouteHelper";

export default {
  name: "BtnCompartir",
  props: {
    id: {type: Number, required: true},
    titulo: {type: String, required: true},
    descripcion: {type: String, required: true},
    peticionCompartir: {type: Function, required: true},
  },
  data: () => ({
    dialog: false,
    loading: false,
    url: null
  }),
  computed: {
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    mostrarDialogo() {
      this.cargarEnlace();
      this.dialog = true;
    },
    cargarEnlace() {
      this.loading = true;
      this.peticionCompartir(this.id)
          .then((resp) => {
            this.url = RouteHelper.url(resp.url);
          })
          .finally(() => {
            this.loading = false;
          });

    },
    copiarEnlace() {
      navigator.clipboard.writeText(this.url);
      this.$store.commit(MOSTRAR_SNACKBAR, {texto: this.$t('enlace_copiado'), color: "info"});
    },
    cerrar() {
      this.dialog = false;
    },
  },
}
</script>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "copiar": "Copiar",
    "boton_copiar": "Copiar enlace",
    "enlace_copiado": "Enlace copiado al portapaleles",
    "compartir": "Compartir"
  }
}
</i18n>
<!--@formatter:on-->
